import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherProgrammingLanguages = () => {
  const { profileDetails } = useProfileContext()
  const programmingLanguages =
    profileDetails?.teacher?.programmingLanguages || {}

  const entries = Object.entries(programmingLanguages).filter(
    ([, group]) => group.items && group.items.length > 0
  )

  if (entries.length === 0) return null

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10">
        <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
          Programming languages
        </h2>
        <ul className="list-disc list-inside space-y-2 text-grey-900 text-base">
          {entries.map(([key, group]) => (
            <li key={key}>
              <span className="font-600">{group.label}:</span>{' '}
              {group.items.join(', ')}
            </li>
          ))}
        </ul>
      </section>
    </>
  )
}

export default React.memo(TeacherProgrammingLanguages)
